// _authenticated — layout route gating + AppShell wrap.
// -----------------------------------------------------------------
// Per dispatch m3-2-auth-rules-listener.md § 6.11.
//
// TanStack Router treats files named `_<segment>.tsx` as layout
// routes — they don't add a path segment, but their component
// wraps every child route's render. Children live in
// `src/routes/_authenticated/`.
//
// Layout = ProtectedRoute + AppShell. Children render via
// AppShell's <Outlet />.

import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { AppShell } from '@/components/AppShell';

const AuthenticatedLayout = () => (
  <ProtectedRoute>
    <AppShell>
      <Outlet />
    </AppShell>
  </ProtectedRoute>
);

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
});
